import { useFeatureValue } from '@monofront/business/contexts';
import {
  FREE_SHIPPING_THRESHOLD,
  MINIMUM_ORDER_AMOUNT,
} from '@monofront/business/constants';
import PiggyLove from '@monofront/design-system/visuals/Icons/Old/PiggyLove';
import Support from '@monofront/design-system/visuals/Icons/Old/Support';
import Delivery from '@monofront/design-system/visuals/Illustrations/Delivery';
import {
  IListBox,
  IListBoxLine,
} from '@monofront/design-system/components/ListBox';
import { OurGuaranteesKeys } from '../types';
import useI18n from '@hooks/i18n/useI18n';
import { useMemo } from 'react';

const useOurProspectGuaranteesContent = ({
  isShoppingCartFUF,
}: {
  isShoppingCartFUF: boolean;
}): IListBox<OurGuaranteesKeys> => {
  const freeShippingThreshold = useFeatureValue(...FREE_SHIPPING_THRESHOLD);
  const minimumOrderAmount = useFeatureValue(...MINIMUM_ORDER_AMOUNT);
  const { isFrenchMarket } = useI18n();

  const lines = useMemo(() => {
    const lines: IListBoxLine<OurGuaranteesKeys>[] = [
      {
        icon: Delivery,
        text: isShoppingCartFUF ? 'prospect.line_1_fuf' : 'prospect.line_1',
      },
      {
        icon: Support,
        text: 'prospect.line_2',
        variables: {
          freeShippingThreshold: freeShippingThreshold.toString(),
          minimumOrderAmount: minimumOrderAmount.toString(),
        },
      },
      {
        icon: PiggyLove,
        text: 'prospect.line_3',
        variables: {
          freeShippingThreshold: freeShippingThreshold.toString(),
        },
      },
    ];

    // remove the second line for the French market for a DDPP purposes
    if (isFrenchMarket) {
      lines.splice(1, 1);
    }

    return lines;
  }, [isFrenchMarket]);

  return {
    title: 'prospect.title',
    lines,
  };
};

export default useOurProspectGuaranteesContent;
